import { useEffect } from "react";
import { X } from "lucide-react";

const ConfirmDialog = ({ open, title, description, confirmLabel, cancelLabel, onConfirm, onCancel, testId = "confirm-dialog" }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
      data-testid={testId}
    >
      <div
        className="absolute inset-0 bg-[#0B1437]/85 backdrop-blur-sm"
        onClick={onCancel}
        data-testid={`${testId}-overlay`}
      />
      <div className="relative grid-card w-full max-w-md p-8 fade-up">
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-[#B79A5A] hover:text-[#D4AF37] transition-colors duration-300"
          aria-label="close"
          data-testid={`${testId}-close`}
        >
          <X className="w-4 h-4" strokeWidth={1.5} />
        </button>
        <span className="overline">Conferma</span>
        <h3 className="font-heading text-3xl mt-3 tracking-tighter text-[#EDE7D8]">{title}</h3>
        {description ? (
          <p className="text-sm text-[#EDE7D8]/75 mt-3 leading-relaxed">{description}</p>
        ) : null}
        <div className="mt-8 flex flex-wrap gap-3 justify-end">
          <button onClick={onCancel} className="btn-ghost" data-testid={`${testId}-cancel`}>
            {cancelLabel || "Annulla"}
          </button>
          <button onClick={onConfirm} className="btn-pill" data-testid={`${testId}-confirm`}>
            {confirmLabel || "Conferma"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
